/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { OrgchartService } from './services/orgchart.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    OrgchartService,
    ApiConfiguration
  ],
})
export class OrgChartApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<OrgChartApiModule> {
    return {
      ngModule: OrgChartApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: OrgChartApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('OrgChartApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
